import { Col } from 'react-bootstrap'
import { IVehicleData, IVehicleInfo } from 'types/vehicleTypes'
import { IAuctionInfo } from 'types/auctionTypes'
import { PropsWithChildren, useEffect, useState } from 'react'
import { setCustomClick } from 'utils/analyticsUtils'
import { getBuyItNowUrl, getVdpUrl } from 'utils/urlUtils'
import { Link } from 'components/Share/Link'
import { useVehicleStore } from 'store/useVehicleStore'
import { useCountdown } from 'hooks/useCountdown'
import {
  StyledAuctionCardRow,
  StyledAuctionTitle,
  StyledAuctionText,
  StyledVehicleBidBuyInformation
} from 'modules/BuyerActivity/VehicleAuction.styled'
import { StyledAuctionTimeRemaining } from 'modules/BuyerActivity/CountDown.styled'
import {
  StyledNotInterestedButton,
  StyledPrice,
  StyledPurchaseButton,
  StyleVehicleDataCard
} from './VehicleDataCard.styled'
import { waiveVehicle } from 'apis/vehicleApis'
import { OverlayLoader } from 'components/Loader'
import { useGlobalStore } from 'store/useGlobalStore'

interface IProps {
  showButton?: boolean
  vehicleData: IVehicleData
  isAwaitingInspection?: boolean
}

interface IVehicleLinkProps {
  vehicle: IVehicleInfo
  auctionInfo?: IAuctionInfo
  customName: string
  vehicleShowOn?: string
}

export const VehicleLink = ({
  customName,
  vehicle,
  auctionInfo,
  children,
  vehicleShowOn
}: PropsWithChildren<IVehicleLinkProps>) => {
  const handleClick = () => {
    setCustomClick(`Dashboard: BuyerActivity:${vehicleShowOn}:IndividualVehicle`, { usePageName: false })
  }

  const detailUrl = getVdpUrl(vehicle.InstanceID)

  return (
    <Link to={detailUrl} onClick={handleClick}>
      {children}
    </Link>
  )
}
const purchaseHandle = (vehicleInstanceID: number) => {
  window.location.href = getBuyItNowUrl(vehicleInstanceID)
}

export const VehicleDataCard = ({ vehicleData, isAwaitingInspection }: IProps) => {
  const { getBaseVehicle } = useVehicleStore()

  const { vehicle: vehicleInfo, auctionInfo } = vehicleData
  const { seconds: timeOut } = useCountdown(auctionInfo?.EndDate)

  const [isWaiveLoading, setIsWaiveLoading] = useState(false)

  useEffect(() => {
    if (timeOut === 0 && vehicleData.auctionInfo?.IsHighestBidder) {
      getBaseVehicle(vehicleData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeOut, vehicleData.auctionInfo?.IsHighestBidder])

  const notInterestingHandle = async (vehicleInstanceID: number) => {
    setIsWaiveLoading(true)
    try {
      await waiveVehicle(vehicleInstanceID)
    } finally {
      setIsWaiveLoading(false)
      window.location.href = '/'
    }
  }
  return (
    <>
      {isWaiveLoading && <OverlayLoader />}
      <StyleVehicleDataCard>
        <StyledAuctionCardRow>
          <Col sm={6}>
            <StyledAuctionTitle>
              <VehicleLink customName="Title" auctionInfo={auctionInfo} vehicle={vehicleInfo}>
                {vehicleInfo?.Title}
              </VehicleLink>
            </StyledAuctionTitle>
            <StyledAuctionText>VIN {vehicleInfo.VIN}</StyledAuctionText>
            <StyledAuctionText>{vehicleInfo?.MileageString} miles</StyledAuctionText>
            <StyledAuctionText>
              <strong>Inspection Status: </strong> {vehicleInfo?.inspectionStatusUpdates?.Status}
            </StyledAuctionText>
            <StyledAuctionText>
              <strong>Inspection ETA: </strong> {vehicleInfo?.inspectionStatusUpdates?.AssignedDateString}
            </StyledAuctionText>
            {!(vehicleInfo.OfferID !== undefined && vehicleInfo.OfferID > 0) && (
              <StyledAuctionText>
                <strong>Grounded On: </strong>
                {vehicleInfo?.GroundingCompletionDate}
              </StyledAuctionText>
            )}
          </Col>
          <Col sm={6}>
            <StyledVehicleBidBuyInformation>
              <div>
                {!(
                  vehicleInfo.OfferID !== undefined &&
                  vehicleInfo.OfferID > 0 &&
                  vehicleInfo.CounterOfferPriceString !== undefined
                ) && <StyledPrice>{vehicleInfo?.FinalPriceString}</StyledPrice>}
                <StyledAuctionTimeRemaining color="#000">
                  {vehicleInfo?.TimeLeft &&
                    (isAwaitingInspection ? (
                      <strong>
                        {vehicleInfo?.TimeLeft} <br />
                        in current status
                      </strong>
                    ) : (
                      <strong>{vehicleInfo?.TimeLeft} left</strong>
                    ))}
                </StyledAuctionTimeRemaining>
              </div>
              {vehicleInfo.showPrice && (
                <div className="dashboard-reserver-bid">
                  <StyledNotInterestedButton onClick={() => notInterestingHandle(vehicleInfo.InstanceID)}>
                    NOT INTERESTED
                  </StyledNotInterestedButton>
                  <StyledPurchaseButton type="submit" onClick={() => purchaseHandle(vehicleInfo.InstanceID)}>
                    PURCHASE
                  </StyledPurchaseButton>
                </div>
              )}
            </StyledVehicleBidBuyInformation>
          </Col>
        </StyledAuctionCardRow>
      </StyleVehicleDataCard>
    </>
  )
}
